import React, { Component } from 'react';
import API from '../../../api/api';
import './index.less';
import { Table, Button, Input, message } from 'antd';

class MusicList extends Component {

    constructor(props) {
        super(props);
    }

    state = {
        pagination: {
            hideOnSinglePage: false,
            showQuickJumper: false,
            showSizeChanger: false,
            addModalTitle: '',
            pageSize: 10,
            current: 1,
            total: 0,
            showTotal: total => `总${total}条`,
            position: 'bottom',
        },
        mainList: [
            {
                circleId: '123',
                circleName: '就啊纠结啊姐',
                userName: '哈哈哈'
            },
        ],
        columns: [
            {
                title: '音乐公众圈ID',
                dataIndex: 'circleId',
                key: 'circleId',
            },
            {
                title: '音乐公众圈名称',
                dataIndex: 'circleName',
                key: 'circleName',
            },
            {
                title: '管理员',
                dataIndex: 'userName',
                key: 'userName',
                render:(text, record)=>(
                    <span>{text}(ID:{record.userId})</span>
                )
            },
            {
                title: '操作',
                key: 'isFreeze',
                render: (text, record, index) => (
                    <div className="operateBtnBlock">
                        <Button onClick={this.addOrEdit.bind(this, record)} type="primary" className="deleteBtn" style={{ marginRight: '10px' }}>编辑公众圈信息</Button>
                        <Button onClick={this.goManage.bind(this, record)} type="primary" className="deleteBtn">管理音乐</Button>
                    </div>
                ),
            },
        ],

        searchCondition: {
            pageNo: 1,
            pageSize: 10,
            keyword: '',
        }

    }

    componentDidMount() {
        this.getListData('homePage');
    }

    async getListData(type) {
        let { pagination, searchCondition } = this.state;
        if ('homePage' == type) {
            searchCondition.pageNo = 1
            pagination.current = 1
        }
        let result = await API.musicCircleList(searchCondition);
        if (result.status == 1) {
            let mainList = result.data.datas;
            pagination.total = Number(result.data.totalNum);
            this.setState({
                pagination,
                mainList
            })
        }
    }

    addShop() {
        this.props.history.push({ pathname: "/themeFlightShopDetail", state: { isNew: true } })
    }

    goManage(item) {
        console.log('item', item)
        this.props.history.push({ pathname: "/music/manage", state: { circleId: item.circleId } })
    }

    addOrEdit(item) {
        console.log('item', item)
        this.props.history.push({ pathname: "/music/addOrEdit", state: { circleId: item ? item.circleId : '' } })
    }

    async deleteFuncOrDis(data) {
        let result = await API.couponDeleteShop({
            templateId: data.templateId
        })
        if (result.status == 1) {
            message.success('删除成功');
            this.getListData();
            return;
        }
        message.error(result.msg);
    }

    handleTableChange = (pagination) => {
        let { searchCondition } = this.state;
        console.log('pagination.current', pagination.current)
        searchCondition.pageNo = pagination.current;
        const pager = { ...this.state.pagination };
        pager.current = pagination.current;
        this.setState({
            pagination: pager,
            searchCondition
        }, () => {
            this.getListData();
        });
    };

    onShowSizeChange = (current, pageSize) => {
        let { searchCondition, pagination } = this.state;
        pagination.pageSize = pageSize
        pagination.current = 1
        searchCondition.pageSize = pageSize;
        searchCondition.pageNo = 1;
        this.setState({
            pagination,
            searchCondition
        }, () => {
            this.getListData();
        });
    }

    InputItemChange(target, e) {
        let value = e.target.value.trim();
        console.log('value', e)
        let { searchCondition } = this.state;
        searchCondition[target] = value
        console.log('searchCondition', searchCondition)
        this.setState({ searchCondition })
    }


    searchForData() {//搜索
        this.getListData('homePage');
    }

    reset() {
        this.setState({
            searchCondition: { keyword: '' }
        }, () => {
            this.getListData('homePage');
        })
    }

    render() {
        const {
            columns,
            mainList,
            pagination,
            searchCondition
        } = this.state;
        return (
            <div className='musicList'>
                <Button type="primary" className='sensitive-btn' onClick={this.addOrEdit.bind(this)}>创建音乐公众圈</Button>
                <div className='search-model'>
                    <Input className='input-userId' value={searchCondition.keyword} onChange={this.InputItemChange.bind(this, 'keyword')} placeholder="公众圈ID\公众圈名称\管理员"></Input>
                    <Button type="primary" onClick={this.searchForData.bind(this)}>搜索</Button>
                    <Button type="primary" onClick={this.reset.bind(this)} style={{ marginLeft: '20px' }}>重置</Button>
                </div>
                <Table columns={columns}
                    dataSource={mainList}
                    pagination={pagination}
                    onChange={this.handleTableChange}
                    onShowSizeChange={this.onShowSizeChange}
                    rowKey={(row, index) => index}
                />
            </div>
        )
    }
}

export default MusicList;